import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldAlert } from "lucide-react";
import { FEATURED_BRIEFING, briefingPath } from "@/data/featuredBriefing";

// Homepage "Latest Legal & Regulatory Update" section. Config-driven so the
// weekly briefing only needs updating in featuredBriefing.js.
export const FeaturedBriefing = () => {
  const b = FEATURED_BRIEFING;
  if (!b.active) return null;

  return (
    <section
      data-testid="homepage-featured-briefing"
      className="bg-charcoal text-canvas py-20 md:py-28 border-y border-gold/20"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "0px 0px -80px 0px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center"
        >
          {/* Left — label + title + jurisdictions */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.24em] uppercase text-gold">
                <ShieldAlert className="w-4 h-4" strokeWidth={1.6} />
                Latest Legal &amp; Regulatory Update
              </span>
            </div>
            <h2 className="font-serif text-2xl md:text-4xl leading-tight">
              {b.title}
            </h2>
            <p className="mt-3 font-sans text-[12px] tracking-[0.14em] uppercase text-canvas/55">
              {b.dateRange}
            </p>
            <div className="mt-6 flex flex-wrap gap-2" data-testid="featured-briefing-jurisdictions">
              {b.jurisdictions.map((j) => (
                <span
                  key={j}
                  className="font-sans text-[10px] tracking-[0.16em] uppercase text-gold/90 border border-gold/40 px-2.5 py-1"
                >
                  {j}
                </span>
              ))}
            </div>
          </div>

          {/* Right — summary + CTA */}
          <div className="lg:col-span-5 lg:border-l lg:border-canvas/15 lg:pl-16">
            <p className="font-serif text-lg md:text-xl text-canvas/80 leading-relaxed">
              {b.summary}
            </p>
            <Link
              to={briefingPath()}
              data-testid="featured-briefing-cta"
              className="group mt-8 inline-flex items-center gap-2.5 font-sans text-xs tracking-[0.14em] uppercase font-bold px-8 py-4 bg-gold text-charcoal border border-gold transition-colors duration-300 hover:bg-canvas hover:border-canvas"
            >
              View Key Risks and Actions
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
